import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'

import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

import {LogRecord} from '@app/core/services/rest-api.model'
import {LogRecordService} from '@app/core/services/logrecord/logrecord.service'
import {map} from 'rxjs/operators'

@Injectable()
export class LogsListService extends GenericListService<object> {
  terminalId: number = null

  constructor(
    private logRecordService: LogRecordService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<object>> {
    return this.logRecordService.getLogRecords(this.terminalId).pipe(
      map((records: LogRecord[]) => {
        return {
          total: records.length,
          items: records.sort((a, b) => b.id - a.id),
        }
      }),
    )
  }
}
